import type { ButtonProps } from '@archipro-design/aria';
import {
    Button,
    pxToRem,
    labelClassName,
    useTheme,
} from '@archipro-design/aria';

import { MapPinLine } from '@archipro-design/icons';

interface WhereToBuyButtonProps extends Pick<ButtonProps, 'onClick'> {}

export const WhereToBuyButton = ({ onClick }: WhereToBuyButtonProps) => {
    const theme = useTheme();

    return (
        <Button
            size={20}
            fluid
            variant="outlined"
            onClick={onClick}
            iconAfter={<MapPinLine />}
            variables={{
                iconPadding: 0,
                buttonSize20IconXMargin: pxToRem(8),
            }}
            // use inline styles to avoid overriding
            styles={{
                marginTop: pxToRem(8),
                padding: pxToRem(13),
                border: `1px solid ${theme.siteVariables.colors.charcoal[100]}`,
                [`& .${labelClassName}`]: {
                    ...theme.siteVariables.textStyles.GTAmericaTrialFont.Bold75,
                    textTransform: 'uppercase',
                    fontSize: `${pxToRem(16)}`,
                    lineHeight: `${pxToRem(17.6)}`,
                },
            }}
        >
            where to buy
        </Button>
    );
};
